import * as React from 'react'
import * as styles from './Button.css'
import { FontAwesomeIcon, FontAwesomeIconType } from '../icon/FontAwesomeIcon'
import { CustomIcon } from '../icon/CustomIcon'
import { IconNames } from '../icon/CustomVectors'
import { Loader } from '../loading-animation/Loader'

export enum ButtonVariant {
	PrimaryRed = 'red',
	SecondaryGray = 'gray',
	CTA = 'goldenGradient',
	Ghost = 'ghost',
}

export enum ButtonShape {
	Square = 'square',
	Round = 'round',
}

export enum ButtonSize {
	Small = 'small',
	Medium = 'medium',
	Large = 'large',
}

export enum ButtonTheme {
	Light = 'light',
	Dark = 'dark',
}

export interface ButtonProps {
	id: string
	dataTestId?: string
	children: string | JSX.Element
	customIcon?: IconNames
	fontAwesomeIcon?: FontAwesomeIconType
	leftIcon?: boolean
	rightIcon?: boolean
	variant?: ButtonVariant
	size?: ButtonSize
	shape?: ButtonShape
	title?: string
	className?: string
	onClick?: React.MouseEventHandler<HTMLButtonElement>
	disabled?: boolean
	minWidth?: string
	loading?: boolean
	widthFillContainer?: boolean
	type?: 'submit' | 'reset'
	theme?: ButtonTheme
}

export function Button({
	children,
	id,
	dataTestId,
	leftIcon = true,
	rightIcon,
	shape = ButtonShape.Square,
	title,
	variant = ButtonVariant.PrimaryRed,
	size = ButtonSize.Medium,
	className,
	onClick,
	customIcon,
	fontAwesomeIcon,
	minWidth,
	disabled = false,
	loading = false,
	widthFillContainer = false,
	theme = ButtonTheme.Dark,
	type,
}: ButtonProps) {
	let iconSize = ''
	switch (size) {
		case ButtonSize.Small:
			iconSize = '14px'
			break
		case ButtonSize.Medium:
			iconSize = '16px'
			break
		case ButtonSize.Large:
			iconSize = '18px'
	}

	const icon = customIcon ? (
		<CustomIcon name={customIcon} size={iconSize} />
	) : fontAwesomeIcon ? (
		<FontAwesomeIcon fontSize={iconSize} fontAwesomeName={fontAwesomeIcon} />
	) : null

	const disabledButtonTheme = theme === ButtonTheme.Dark ? styles.disabled : styles.lightDisabled

	return (
		<button
			id={id}
			data-testid={dataTestId}
			className={`
                ${className}
                ${styles.button}
                ${styles[variant]}
                ${styles[size]}
                ${styles[shape]}
                ${disabled ? disabledButtonTheme : ''}
                ${widthFillContainer ? styles.width100Percent : ''}
            `}
			title={title}
			onClick={onClick}
			style={minWidth ? { minWidth } : null}
			disabled={disabled}
			type={type}
		>
			{loading === true ? (
				<Loader />
			) : (
				<>
					{leftIcon && icon}
					{children}
					{rightIcon && icon}
				</>
			)}
		</button>
	)
}
